export default {"src":"/booking/_next/static/media/logo-new-white.36615a7a.svg","height":146,"width":514,"blurWidth":0,"blurHeight":0};